 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		0: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"1":"vue","2":"d3js","11":"d3_snowhist","12":"leaflet","13":"location-subnavigation","15":"modal-feedback","16":"modal-feedback-detail-feedback","17":"modal-feedback-error","18":"modal-feedback-simple-select","19":"modal-feedback-success","23":"show-history-page","24":"sign-up","25":"sign-up/app-free-features-vue","26":"sign-up/snow-pro-benefits-vue","27":"sign-up/social-auth-buttons-vue","28":"sign-up/the-finish-vue","29":"sign-up/the-form-free-vue","30":"sign-up/the-form-premium-vue","31":"sign-up/the-payment-vue","32":"sign-up/the-plan-selection-vue","33":"sign-up/the-promo-login-vue","34":"sign-up/the-promo-signup-vue","35":"signup","36":"snow-history-snow-depth","37":"snow-report-page","39":"vendors~leaflet","40":"visual-report-detail-report","41":"visual-report-error","42":"visual-report-simple-select","43":"visual-report-success","44":"visualReport"}[chunkId]||chunkId) + "-" + {"1":"02776e7bb602122ed31d","2":"b82adb72849b995c1b1a","11":"688711024d4c7dabb840","12":"95b0758de4883795ff98","13":"673be12a996e23e78a1c","15":"8c4d34d699740d4401ca","16":"3e83e8080f81c71d9e73","17":"8df4dc67028b41c8287b","18":"c2dc63ba0a8da1901962","19":"ece12df29358c582a6a8","23":"778fb917e0d5100552db","24":"5b08005606811406bc63","25":"8175dc6490ff70515375","26":"c7f9edce2a9d565fef9e","27":"3506ae92fa3867fb299b","28":"aead1ea0bc5666257227","29":"adbde02c3833c4c1b8ff","30":"b4948fe1edeba5aab33b","31":"249ab3a3251af21b0776","32":"74442fde0dfdfb18a6a1","33":"7490d68b870a73aa79a1","34":"8ac161ec7cda97e0ac1c","35":"0a7258a551b2d783a7a0","36":"b830165df6416749ffac","37":"43cd8b3136cfebd33727","39":"06d0f5e5e2cd12fde0cb","40":"f6b9aee9ffda80982bea","41":"5b3192aa1243ca2550b1","42":"d63c79b63f6330b58e6e","43":"14ab804a9cd8ad018e8b","44":"1447c32df6c98c827cb5"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"11":1,"12":1,"15":1,"16":1,"17":1,"18":1,"19":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"1":"vue","2":"d3js","11":"d3_snowhist","12":"leaflet","13":"location-subnavigation","15":"modal-feedback","16":"modal-feedback-detail-feedback","17":"modal-feedback-error","18":"modal-feedback-simple-select","19":"modal-feedback-success","23":"show-history-page","24":"sign-up","25":"sign-up/app-free-features-vue","26":"sign-up/snow-pro-benefits-vue","27":"sign-up/social-auth-buttons-vue","28":"sign-up/the-finish-vue","29":"sign-up/the-form-free-vue","30":"sign-up/the-form-premium-vue","31":"sign-up/the-payment-vue","32":"sign-up/the-plan-selection-vue","33":"sign-up/the-promo-login-vue","34":"sign-up/the-promo-signup-vue","35":"signup","36":"snow-history-snow-depth","37":"snow-report-page","39":"vendors~leaflet","40":"visual-report-detail-report","41":"visual-report-error","42":"visual-report-simple-select","43":"visual-report-success","44":"visualReport"}[chunkId]||chunkId) + "-" + {"1":"e3b0c44298fc1c149afb","2":"e3b0c44298fc1c149afb","11":"9d71c02e4e1e14f19178","12":"b59749687b2067cd4cf6","13":"e3b0c44298fc1c149afb","15":"084508a9f826bc09c56e","16":"ba9ecbc3d83fea4592ef","17":"3452f499dfac52679c8b","18":"1fca309d715eea28656e","19":"1dfd6c590f960ff10a92","23":"db0e69d5aec0b744ffcb","24":"50fa370635ab597c48e2","25":"f21b398619ef78568f53","26":"02e65f2ecfbcdc120133","27":"4bd220a923169769a9d8","28":"9c206a8a05288b1c7864","29":"c338e69072a02c0e8933","30":"ec9996d078209306d8be","31":"68799eeba81b4b90f00d","32":"0334f53a031f9a46d1ed","33":"5fc843f50728f7791aa7","34":"4c8445059b3fa643097c","35":"65adf89801faba706f3b","36":"26aa4ebbb83bbc4ef924","37":"26aa4ebbb83bbc4ef924","39":"2e6ddc2d7e6698f3c70d","40":"44757b1d68294caadbb1","41":"b702a7a17b84696b21ed","42":"aa2118b9635ef3a51881","43":"e6d09e0b932c4e93f252","44":"50d22f40d0fb14dee8ca"}[chunkId] + ".chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
